import { Inject, Injectable } from '@angular/core';
import { marker as i18n } from '@ngneat/transloco-keys-manager/marker';
import { map, Observable } from 'rxjs';
import { TranslateFunction } from '@bbraun/shared/util-transloco-ng';
import {
  ValidatorFactory,
  ValidatorFactoryFunction,
} from '@bbraun/bav-reporting/ui-report-editor';
import { createIsBooleanValidator } from '../create-validators';
import { FeatureAisReportsScopedTranslationService } from '../../../services/feature-ais-reports-scoped-translation.service';

export const IS_BOOLEAN_ID = 'IS_BOOLEAN';
export const IS_BOOLEAN_ERROR = Symbol(IS_BOOLEAN_ID);

@Injectable({
  providedIn: 'root',
})
export class IsBooleanValidatorFactory implements ValidatorFactory<undefined> {
  readonly id = IS_BOOLEAN_ID;
  readonly validatorFn: Observable<ValidatorFactoryFunction<undefined>>;

  constructor(
    @Inject(FeatureAisReportsScopedTranslationService)
    private readonly scopedTranslationService: {
      loadedLang$: Observable<{ translate: TranslateFunction }>;
    },
  ) {
    this.validatorFn = this.scopedTranslationService.loadedLang$.pipe(
      map(({ translate }) => () => ({
        id: IS_BOOLEAN_ERROR,
        validate: createIsBooleanValidator(),
        message: translate(
          i18n(
            'bbraunBavReportingFeatureAisReports.validation.property.notBoolean.error.message',
          ),
        ),
      })),
    );
  }
}
